<template>
  <button
    class="reset-filters-button"
    :disabled="disabled"
    @click="onClick($event)"
  >
    <IconCircleX width="16" height="16" />
    {{ label }}
  </button>
</template>
<script>
import IconCircleX from "../../Icons/IconCircleX.vue";
export default {
  name: "ResetFiltersButton",
  components: {
    IconCircleX,
  },
  props: {
    label: {
      type: String,
      required: true,
      default: "Clear all filters",
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    onClick($event) {
      /**
       * Emitted when the button is clicked.
       * @event click
       * @type {Event}
       */
      this.$emit("click", $event);
    },
  },
};
</script>
